<template>
<div>
    

    <modal name="settings" v-if="!loading && hotel" :width="modal.width" :minWidth="360" :maxWidth="1040" :height="modal.height" :adaptive="true" scrollable>
      <div class="grid edit settings w100">

        <div class="grid data h50" v-if="!addbeachitem">
          <h1>{{hotel.name}}</h1>

          <!-- {{hotel.poolsettings}} -->

          <el-form>

          <el-form-item label="Nome Hotel">
            <el-input v-model="hotel.name"></el-input>
          </el-form-item>
<!-- 
          <div class="grid" style="grid-auto-flow: column; justify-content: space-between;">

          <div>
          <label class="el-form-item__label">Righe in Spiaggia</label>
          <el-form-item >
            <el-input-number v-model="hotel.rows" :min="1" ></el-input-number>
          </el-form-item>
          </div>

          <div>
          <label class="el-form-item__label">Colonne in Spiaggia</label>
          <el-form-item >
            <el-input-number v-model="hotel.cols" :min="1" ></el-input-number>
          </el-form-item>
          </div>

          </div> -->

          <div class="grid" style="grid-auto-flow: column;">

          <!-- <el-radio-group v-model="hotel.lang">
            <el-radio-button v-for="(lang, index) in langs" :key="index" :label="lang.lang">{{lang.lang}}</el-radio-button>
          </el-radio-group> -->

          <span class="grid colorpicker" style="grid-auto-flow: column;">

          <label class="el-form-item__label">Colore Hotel</label>

          <el-color-picker size="small" v-model="hotel.colors.primary"></el-color-picker>

          <!-- <el-color-picker v-model="hotel.colors.secondary"></el-color-picker> -->

          </span>

          </div>

          </el-form>

          <div class="spacer xs"></div>

          <!-- <label class="">Colore Hotel</label> -->

          <div class="grid settings">
            <span>Numero camera</span>
            <el-switch active-color="#00B325" v-model="hotel.poolsettings.room"></el-switch>
            <span>Nome ospite</span>
            <el-switch active-color="#00B325" v-model="hotel.poolsettings.guest"></el-switch>
            <!-- <span>Sdraio</span> -->
            <!-- <el-switch active-color="#00B325" v-model="hotel.poolsettings.beds"></el-switch> -->
            <span>Oggetti spiaggia</span>
            <el-switch active-color="#00B325" v-model="hotel.poolsettings.chairs"></el-switch>
            <span>Arrivo e Partenza</span>
            <el-switch active-color="#00B325" v-model="hotel.poolsettings.arrival"></el-switch>
            <!-- <span>Data partenza</span> -->
            <!-- <el-switch active-color="#00B325" v-model="hotel.poolsettings.departure"></el-switch> -->
            <span>Booking Ombrellone singolo giorno</span>
            <el-switch active-color="#00B325" v-model="hotel.singledaybooking"></el-switch>
          </div>

          <div class="spacer sm"></div>
          <el-button v-on:click="updatehotel" class="btn btn-green block">Salva Impostazioni</el-button>
          <div class=" spacer md"></div>
        </div>

        <div class="addbeachitem" v-if="addbeachitem">

        <h3>Aggiungi oggetto in spiaggia</h3>

        <!-- {{beachitem}} -->

        <div class="spacer sm"></div>
          
        <el-form>

          <el-form-item label="Nome oggetto in spiaggia">
            <el-input placeholder="Nome oggetto spiaggia" v-model="beachitem.name"></el-input>
          </el-form-item>

          <el-form-item>
            <el-radio v-model="beachitem.icon" label="grid" border><i class="far fa-grin-tongue-wink"></i></el-radio>
          </el-form-item>

          <p><a v-on:click="updatebeachitems" class="btn btn-green">Aggiungi oggetto</a></p>

        </el-form>

        </div>

        <div class="grid seats h50" :style="{background: hotel.colors.primary}" :class="{ neutral : passForm }">
        <!-- {{hotel.items}} -->
        <!-- <button type="button" class="btn btn-blue" v-on:click="modal.width = '100%'">add item</button> -->
          <div class="grid" v-for="(item, index) in hotel.items" v-if="!passForm">     
            <span v-html="item.icon"></span>
            <span v-if="!addbeachitem"><a v-on:click="item.num -= 1"><span class="fa fa-minus-square"></span></a>{{item.num}}<a v-on:click="item.num += 1"><span class="fa fa-plus-square"></span></a></span>
            <span v-if="addbeachitem" v-on:click="deletebeachitem(index)"><i class="fas fa-trash"></i></span>
          </div>

          <div class="grid" v-if="passForm">
            <el-form ref="changepassForm" :model="formel" :rules="rules">

              <el-form-item label="Inserisci la tua nuova password" prop="password">
                  <el-input v-model="formel.password" show-password placeholder="Password" prefix-icon="fas fa-key" name="password"></el-input>
                </el-form-item>
              <div class="spacer xs"></div>
              <el-form-item>
                <el-button class="btn btn-green block" @click="changepassword('changepassForm')">salva password</el-button>
              </el-form-item>

            </el-form>
          </div>
<!--           <div class="grid">     
            <img src="../assets/img/beach-deckchair-@2x.png">
            <span><a v-on:click="hotel.chairs -= 1"><span class="fa fa-minus-square"></span></a>{{hotel.chairs}}<a v-on:click="hotel.chairs += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>
          <div class="grid">
            <img src="../assets/img/beach-chair@2x.png">
            <span><a v-on:click="hotel.beds -= 1"><span class="fa fa-minus-square"></span></a>{{hotel.beds}}<a v-on:click="hotel.beds += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>  -->         
        </div>

        <div class="grid navi" :style="{ background: hotel.colors.primary }" :class="{ neutral : passForm }">

        <div class="grid shader">

          <div class="options">
            
            <!-- <el-tooltip class="item" effect="dark" content="Aggiungi oggetto spiaggia" placement="left-start">
              <el-button v-on:click="addbeachitem = true"><i class="fas fa-plus-square"></i></el-button>
            </el-tooltip> -->

            <el-tooltip class="item" v-if="hotel.beachtype == 'grid'" effect="dark" content="Cambia impostazioni spiaggia" placement="left-start">
              <el-button><router-link :to="{path: '/editgrid/' + hotel._id }" class=""><i class="fas fa-th"></i></router-link></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Imposta pagamenti" placement="left-start">
              <el-button><router-link :to="{path: '/pagamenti/' + hotel._id }" class=""><i class="fas fa-cash-register"></i></router-link></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Cambia la tua password" placement="left-start">
              <el-button><i class="fas fa-lock" v-on:click="passForm = true"></i></el-button>
            </el-tooltip>

          </div>

          <div class="footer">
            
            <el-tooltip class="item" effect="dark" placement="left-start">
              <span slot="content">Cancella {{hotel.name}}</span>
              <el-button v-on:click="dialogVisible = true"><i class="fas fa-trash"></i></el-button>
            </el-tooltip>

          </div>

        </div>

        </div>

      </div>
    </modal>

    <el-dialog
      title="Attenzione"
      :visible.sync="dialogVisible"
      width="25%">
      <p>Sei sicuro di voler cancellare {{hotel.name}}?</p>
      <p>Tutti i dati verranno cancellati.</p>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn-secondary" @click="dialogVisible = false">Anulla</el-button>
        <el-button class="btn btn-red" @click="deleteHotel">Cancella</el-button>
      </span>
    </el-dialog>


  
</div>
</template>

<script>
  import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  import 'moment/locale/de'
  import 'moment/locale/it'
  import router from './../router'
  const moment = extendMoment(Moment)
  import Navbar from '@/components/Navbar'
  import { Drag, Drop } from 'vue-drag-drop'
  var host = process.env.ROOT_API
  export default {
    name: 'ombrelli',
    props: ['auth', 'authenticated', 'hotel'],
    data () {
      return {
        alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
        letters: {
          first: 'A',
          last: '',
          act: 0,
          row: 1
        },
        formel: {
          password: ''
        },
        rules: {
          password: [
              { required: true, message: 'prego inserisci una password', trigger: 'blur' },
              { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }
          ]
        },
        modal: {
          width: '70%',
          height: 'auto'
        },
        beachitem: {
          name: '',
          icon: ''
        },
        addbeachitem: false,
        numbers: {
          first: 1,
          last: 0,
          act: 0
        },
        query: '',
        filtered: '',
        loading: false,
        nogrid: false,
        grid: {
          direction: '',
          letter: true,
          number: true,
          firststep: false,
          active: 0
        },
        state1: '',
        passForm: false,
        calcform: false,
        langs: [{
          lang: 'it'
        }, {
          lang: 'de'
        }],
        // hotel: '',
        secret: '',
        // pregrid: '',
        ombrelli: [],
        style: '',
        dialogVisible: false,
        rangestyle: '',
        hotelid: '',
        ombrellos: '',
        addombrello: {
          ombrid: ''
        },
        overview: {
          arrivals: [],
          departures: [],
          stays: []
        },
        date: ['2016-10-16', '2024-10-05'],
        today: moment().format('YYYY-MM-DD'),
        lang: 'it',
        range: {
          startDate: moment(),
          endDate: moment().add(7, 'days')
          // startDate: '2019-04-03',
          // endDate: '2019-04-10'
        },
        rangepicker: [],
        rangeviewdata: '',
        // disabledRange: {
        //   startDate: moment(),
        //   endDate: moment().add(9, 'days')
        // },
        disabledDates: [],
        datePickerOptions: {
          firstDayOfWeek: 1
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        location: 'beach',
        rangeview: false
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Drag,
      Drop
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        console.log('socket connected')
      },
      stream: function (val) {
        // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        // console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          console.log('an umbrella was updated')
          this.getOmbrelli()
        }
      },
      disconnect: function () {
        console.log('socket error')
        this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 5000
        })
      }
    },
    methods: {
      deleteHotel () {
        console.log('hotel: ', this.hotel)
        this.$http
          .post(host + '/api/deletehotel', {hotel: this.hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$notify({
              group: 'foo',
              title: this.hotel.name + ' deleted',
              type: 'info',
              duration: 500
            })
            router.push('/hotel')
          }, (error) => {
            console.log(error)
          })
      },
      updatebeachitems () {
        console.log('add beachitem')
      },
      deletebeachitem (index) {
        console.log(index)
        this.hotel.items.splice(index, 1)
      },
      stepHandler (e, i) {
        console.log(e, i)
        this.grid.active = i
      },
      nextStep () {
        this.grid.active++
      },
      previousStep () {
        if (this.grid.active === 2) {
          this.ombrelli = []
          this.grid.direction = ''
          this.grid.active = 0
        } else {
          this.grid.active--
        }
      },
      filter (query) {
        console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
        this.filtered = this.overview.arrivals.filter(item => item.guest.name === this.query)
      },
      // querySearch (queryString, cb) {
      //   var links = this.linkst
      //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
      //   // call callback function to return suggestions
      //   console.log(results)
      //   cb(results)
      // },
      // createFilter (queryString) {
      //   return (link) => {
      //     // console.log(link, queryString)
      //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      //   }
      // },
      handleSelect (item) {
        console.log(item)
      },
      disabledFunc: function (dayMoment) {
        // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
        if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return true
        } else {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return false
        }
      },
      preCheckDate () {
        // console.log('ombrellos: ', this.ombrellos)
        // console.log(date)
        console.log('preCheckDate')
        this.disabledDates = []
        this.ombrellos.guests.forEach((guest, indexo) => {
          // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
          // console.log('guest: ', guest.name, 'ombrello guest: ', this.ombrellos.guest)
          if (guest.name !== this.ombrellos.guest) {
            var start = moment(guest.arrival, 'YYYY-MM-DD').add('days', 1)
            var end = moment(guest.departure, 'YYYY-MM-DD')
            // console.log('guest name: ', guest.name, 'start: ', start, 'end: ', end)
            var range = moment.range(start, end)
            var dates = Array.from(range.by('days', { excludeStart: true, excludeEnd: true })).map(m => m.format('YYYY-MM-DD'))
            // this.disabledDates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
            Array.prototype.push.apply(this.disabledDates, dates)
            console.log('guest: ', guest.name, dates)
          }
        })
      },
      // checkDate (date) {
        // console.log(moment(date).format('YYYY-MM-DD'))
        // date = moment(date).format('YYYY-MM-DD')
        // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
        // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
        //   return true
        // } else {
        //   return false
        // }
        // this.ombrellos.guests.forEach(function (guest, indexo) {
        //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
        //     return true
        //   } else {
        //     return false
        //   }
        // })
      // },
      handleDragover (group, data, event) {
        // console.log(data)
        // console.log(group.ombrid)
        // console.log(event)
        if (!group.free) {
          event.dataTransfer.dropEffect = 'none'
        }
      },
      handleDrop (group, data, key) {
        console.log(group.ombrello.ombrid, data.target.id)
        this.moveombrello(group.ombrello, data.target.id)
        // alert(`You dropped with data: ${JSON.stringify(data)}`)
      },
      changeombrid () {
        console.log('changeombrid')
        this.editombrid = true
      },
      onChange (range) {
        this.range = range
        console.log(moment(range.endDate._d))
      },
      setRange (p) {
        if (typeof p === 'number') {
          console.log(p)
          this.range = {
            startDate: moment().add(p, 'days'),
            endDate: moment()
          }
        }
      },
      show (ombrello) {
        console.log(ombrello.arrival)
        this.ombrellos = ombrello
        if (ombrello.free) {
          this.ombrellos.chairs = this.hotel.chairs
          this.ombrellos.beds = this.hotel.beds
        }
        // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
        this.date[0] = ombrello.arrival
        this.date[1] = ombrello.departure
        // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
        if (ombrello.arrival) {
          console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
          this.range.startDate = moment(ombrello.arrival)
        }
        if (ombrello.departure) {
          this.range.endDate = moment(ombrello.departure)
        }
        this.preCheckDate()
        this.$modal.show('hello-world')
      },
      hide () {
        this.$modal.hide('hello-world')
      },
      settings () {
        this.$modal.show('settings')
      },
      updatehotel: function () {
        this.$http
          .post(host + '/api/updatehotel', { hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.$modal.hide('settings')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      changepassword (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('passreset')
            this.loading = true
            // this.error.state = false
            this.$http
              .post(host + '/changepassword', {password: this.formel.password},
              {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.jwt
                }
              },
              ).then((data) => {
                // this.ombrelli = data.body.ombrells
                console.log(data)
                this.loading = false
                // this.success.state = true
                // this.success.message = data.body.success
                // localStorage.setItem('jwt', data.body.jwt)
                // localStorage.setItem('profile', data.body.profile)
                // router.replace('Hotel')
                // this.loading = false
                // this.getHotel()
              }, (error) => {
                console.log(error)
                this.loading = false
                // this.error.state = true
                // this.error.message = error.body.error
              })
          } else {
            console.log('error submit!!')
            // return false
          }
        })
      },
      saveOmbrello: function () {
        console.log(this.ombrellos)
        console.log(this.range['endDate'])
        this.$delete(this.ombrellos, '__v')
        this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
        this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
        this.editombrid = false
        // if (this.ombrellos.free && this.ombrellos.ombrid === this.ombrelli) {
        //   console.log(this.ombrellos.ombrid + ' is free so i am not updating guest data')
        //   // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
        // } else {
        //   console.log(this.ombrellos.ombrid + ' has a new guest')
        //   this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
        // }
        this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.departure = ''
        this.ombrellos.guestsinday = []
        this.ombrellos.free = true
        console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests)
        this.$http
          .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updateombrello: function () {
        console.log(this.ombrellos)
        console.log(this.range['endDate'])
        this.$delete(this.ombrellos, '__v')
        this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
        this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
        this.editombrid = false
        // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
        if (this.ombrellos.free) {
          console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data')
          // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
        } else {
          this.ombrellos.guests[this.ombrellos.guestnr] = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
        }
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.departure = ''
        this.ombrellos.guestsinday = []
        this.ombrellos.free = true
        console.log('ombrello update: ', this.ombrellos)
        this.$http
          .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      moveombrello: function (old, newo) {
        console.log(old, newo)
        // this.ombrellos = old
        // this.closeombrello()
        // old._id = newo
        // old.ombrid = ombrid
        // console.log(this.ombrellos)
        // this.ombrellos = newo
        this.$http
          .post(host + '/api/moveombrello', { old: old, newo: newo },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.dragging = null
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      closeombrello (index) {
        console.log(this.ombrellos.guests, index)
        this.ombrellos.guests.splice(index, 1)
        console.log('updated: ', this.ombrellos.guests)
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.departure = ''
        this.ombrellos.free = true
        this.$http
          .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      addombrell: function () {
        console.log(this.addombrello, this.hotelid)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      editguest: function (index) {
        console.log(index.ombrid, index.edit)
        index.edit = true
        // Vue.set(this.ombrelli[index], 'edit', true)
      },
      saveEdit: function (index, guest) {
        // save your changes
        // this.toggleEdit(index, guest)
        console.log(index, guest)
        Vue.set(this.ombrelli[index], 'guest', guest)
      },
      // presetGrid () {
      //   var grid = this.hotel.cols * this.hotel.rows
      //   if (this.ombrelli.length === grid) {
      //     console.log('preset grid done')
      //   } else {
      //     console.log('preset grid not yet done')
      //     if (this.numbers.first < 10) {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         }
      //       }
      //     } else {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         }
      //       }
      //     }
      //   }
      // },
      resetGrid () {
        this.ombrelli = []
        this.grid.firststep = true
        this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        this.letters.row = 1
        this.numbers.act = this.numbers.first
        this.grid.active = 2
        if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
          this.setemptyGrid()
        } else {
          this.setGrid()
        }
      },
      setemptyGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
        if (this.ombrelli.length === grid) {
          console.log('done')
        } else {
          if (grid > 99 && this.numbers.act <= 9) {
            console.log('case: 1')
            this.ombrelli.push({ombrid: '00' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else if (grid > 99 && this.numbers.act <= 99) {
            console.log('case: 2')
            this.ombrelli.push({ombrid: '0' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else {
            console.log('case: 3')
            this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          }
          this.setemptyGrid()
        }
      },
      setGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        if (this.letters.act === this.alphabet.length) {
          this.letters.act = 0
        }
        var act = this.alphabet[this.letters.act].toUpperCase()
        console.log('act: ', act, this.numbers.act)
        if (this.ombrelli.length === grid) {
          console.log('done')
        } else {
          // console.log('not done')
          if (this.numbers.act < 10) {
            this.ombrelli.push({ombrid: act + '0' + this.numbers.act, free: true})
            console.log('nr: ', act + '0' + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          } else {
            this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
            console.log('nr: ', act + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          }
          // if (this.numbers.first < 10) {
          //   this.ombrelli.push({ombrid: act + '0' + this.numbers.first, free: true})
          //   this.letters.act = this.alphabet.indexOf(act) + 1
          //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
          //     this.letters.act = 0
          //     this.letters.row = this.letters.row + 1
          //   }
          //   this.setGrid()
          // } else {
          //   this.ombrelli.push({ombrid: act + this.numbers.first, free: true})
          //   this.letters.act = this.alphabet.indexOf(act) + 1
          //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
          //     this.letters.act = 0
          //     this.letters.row = this.letters.row + 1
          //   }
          //   this.setGrid()
          // }
        }
        // var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        // var act = this.alphabet[this.letters.act]
        // console.log('act: ', act)
        // if (this.ombrelli.length === grid) {
        //   console.log('done')
        // } else {
        //   console.log('not done')
        //   if (this.hotel.rows > 10 && this.letters.row < 10) {
        //     this.ombrelli.push({ombrid: act + '0' + this.letters.row, free: true})
        //     this.letters.act = this.alphabet.indexOf(act) + 1
        //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //       this.letters.act = 0
        //       this.letters.row = this.letters.row + 1
        //     }
        //     this.setGrid()
        //   } else {
        //     this.ombrelli.push({ombrid: act + this.letters.row, free: true})
        //     this.letters.act = this.alphabet.indexOf(act) + 1
        //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //       this.letters.act = 0
        //       this.letters.row = this.letters.row + 1
        //     }
        //     this.setGrid()
        //   }
        // }
      },
      saveGrid: function () {
        console.log(this.ombrelli)
        this.$http
          .post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.getOmbrelli()
            this.nogrid = false
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'grid saved',
              type: 'success',
              duration: 500
            })
          })
      },
      changeDate () {
        console.log(moment(this.today).format('YYYY-MM-DD'))
        this.today = moment(this.today).format('YYYY-MM-DD')
        this.getOmbrelli()
        this.rangeview = false
      },
      changeRange () {
        // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
        var start = moment(this.rangepicker[0], 'YYYY-MM-DD')
        var end = moment(this.rangepicker[1], 'YYYY-MM-DD')
        var range = moment.range(start, end)
        var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
        // console.log('range picker dates: ', dates)
        this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);'
        this.rangeviewdata = dates
        this.rangeview = true
        this.ombrelli.forEach((ombrello, indexo) => {
          // console.log('ombrello: ', ombrello)
          // this.ombrelli.push(ombrello)
          Vue.set(this.ombrelli[indexo], 'dates', [])
          // ombrello.guests.forEach((guest, index) => {
            // console.log('guest: ', guest)
            // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
          dates.forEach((date, indexd) => {
            this.ombrelli[indexo].dates.push({date: moment(date).format('DD/MM'), day: moment(date).format('dd'), guests: [], free: true})
            ombrello.guests.forEach((guest, index) => {
              if (moment(date).isBetween(guest.arrival, guest.departure, null, '[]')) {
                console.log(ombrello.ombrid + ' is occupied on ' + date)
                // this.ombrelli[indexo].dates.push({date: date, guest: guest})
                this.ombrelli[indexo].dates[indexd].guests.push(guest)
                this.ombrelli[indexo].dates[indexd].free = false
              } else {
                // console.log(ombrello.ombrid + ' is free on ' + this.today)
                console.log(ombrello.ombrid + ' is free on ' + date)
                // this.ombrelli[indexo].free = true
                // this.ombrelli[indexo].dates.push({date: date, guest: guest})
              }
            })
          })
        })
      },
      getOmbrelli () {
        this.$http
          .post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log('hotel: ', data.body.ombrells)
            // this.hotelid = data.body.hotels._id
            // this.hotel = data.body.hotels
            moment.locale(data.body.hotels.lang)
            if (data.body.hotels.chairs === undefined) {
              this.hotel.chairs = 1
            }
            if (data.body.hotels.beds === undefined) {
              this.hotel.beds = 1
            }
            // this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
            // console.log('hotel: ' + this.hotelid)
            // console.log(data)
            // this.ombrelli = data.body.ombrells
            // console.log(this.today)
            // this.ombrelli = []
            // data.body.ombrells.forEach((ombrello, indexo) => {
            //   this.ombrelli.push(ombrello)
            //   ombrello.guests.forEach((guest, index) => {
            //     console.log('guest: ', guest)
            //     if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '[]')) {
            //       console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure)
            //       this.ombrelli[indexo].guest = guest.name
            //       this.ombrelli[indexo].room = guest.room
            //       this.ombrelli[indexo].arrival = guest.arrival
            //       this.ombrelli[indexo].departure = guest.departure
            //       this.ombrelli[indexo].free = false
            //       this.ombrelli[indexo].guestnr = index
            //       this.ombrelli[indexo].guestsinday.push(guest)
            //     } else {
            //     }
            //   })
            // })
            // this.getOverview()
            // if (!this.hotel.firststep && data.body.ombrells <= 0) {
            //   this.nogrid = true
            // }
            this.loading = false
          }, (error) => {
            console.log(error)
            this.$router.replace('/')
          })
      },
      getOverview () {
        this.overview.arrivals = []
        this.overview.departures = []
        this.overview.stays = []
        this.ombrelli.forEach((ombrello, indexo) => {
          // console.log('ombrello: ', ombrello)
          // this.ombrelli.push(ombrello)
          ombrello.guests.forEach((guest, index) => {
            console.log('guest: ', guest)
            // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
            if (moment(this.today).isSame(guest.arrival)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
              console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
              this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
            } else if (moment(this.today).isSame(guest.departure)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
              console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
              this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
            } else if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '()')) {
              console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure)
              this.overview.stays.push({guest: guest, ombrid: ombrello.ombrid})
            }
          })
        })
      },
      addchair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
            this.$notify({
              group: 'foo',
              title: 'Chair added',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
          })
      },
      removechair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      addbed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      removebed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      changeguest (index, chair, guest) {
        console.log(this.ombrelli)
        console.log(index, chair, guest)
        // var newchairs = nr - 1
        // this.$http
        //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   },
        //   ).then((data) => {
        //     console.log(data)
        //     // this.loading = false
        //     Vue.set(this.ombrelli[index], 'beds', newchairs)
        //   }, (error) => {
        //     console.log(error)
        //   })
      }
    },
    beforeMount () {
      // this.getOmbrelli()
      // this.letters.act = this.alphabet.indexOf(this.letters.first)
    },
    mounted: function () {
      // this.getOverview()
      // moment.locale(this.hotel.lang)
      // console.log('hotel: ', this.hotel)
    },
    computed: {
      hotelgrid: function () {
      // `this` points to the vm instance
        this.numbers.last = this.hotel.cols * this.hotel.rows
        return this.hotel.cols * this.hotel.rows
      },
      state: function () {
        // console.log('today: ', this.today)
      },
      filteredArrivals () {
        console.log('filteredArrivals')
        return this.overview.arrivals.filter(post => {
          var arrivals = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var arrivalsroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          console.log(arrivals)
          if (arrivals) {
            return arrivals
          } else {
            return arrivalsroom
          }
        })
      },
      filteredDepartures () {
        return this.overview.departures.filter(post => {
          var departures = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var departuresroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (departures) {
            return departures
          } else {
            return departuresroom
          }
        })
      },
      filteredStays () {
        return this.overview.stays.filter(post => {
          var stays = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var staysroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (stays) {
            return stays
          } else {
            return staysroom
          }
        })
      },
      pregrid () {
        var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1
        if (this.letters.first.length > 0) {
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
          }
        } else {
          console.log('no letter', this.hotel.cols)
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: (this.hotel.cols + 1) }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.hotel.cols) + 1) } }
          }
        }
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Settings.vue?548bdb1e